
import axios from 'axios';
import { localStorageService } from './store/localStorage.service';
import { toastService } from './plugins/toast';
import router from '@router/router';
import { useAuthStore } from '@store/auth';
import { useWorkspaceStore } from '@store/WorkspaceData';

// Создаем пустой экземпляр без baseURL
const api = axios.create({
  timeout: 300000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// Флаг инициализации
let isInitialized = false;

// Функция инициализации API с конфигом
export const initApi = (configService) => {
  if (isInitialized) return api;
  
  const locateClient = window.location.origin;
  if(locateClient == 'http://localhost:3000'){
    api.defaults.baseURL = configService.get('api.baseUrl');
  }
  else{
    api.defaults.baseURL = locateClient
  }
  api.defaults.timeout = configService.get('api.timeout');
  api.interceptors.request.clear();
  api.interceptors.response.clear();
  
  api.interceptors.request.use(
    (config) => {
      const token = localStorageService.get('access_token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      if (configService.get('api.debug', false)) {
        console.log(`[API Request] ${config.method.toUpperCase()} ${config.url}`, config);
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  api.interceptors.response.use(
    (response) => {
      if (configService.get('api.debug', false)) {
        console.log(`[API Response] ${response.config.method.toUpperCase()} ${response.config.url}`, response.data);
      }
      return response;
    },
    async (error) => {
      const status = error.response?.status;
      const isLoginRequest = error.config?.url?.includes('/api/auth/login');

      // Обработка 401/403 - сессия недействительна (бэкенд отдаёт 403 и без токена).
      // Refresh на бэкенде пока нет, поэтому сразу выходим.
      // Ошибки самого логина обрабатывает страница входа.
      if ((status === 401 || status === 403) && !isLoginRequest) {
        localStorageService.clear();
        delete api.defaults.headers.common['Authorization'];
        useAuthStore().logout();
        useWorkspaceStore().clear();
        // Несколько запросов могут упасть одновременно — уведомляем один раз
        if (router.currentRoute.value.path !== '/login') {
          toastService.warn('Сессия истекла. Пожалуйста, войдите снова');
          router.push('/login');
        }
        return Promise.reject(error);
      }

      // Обработка 404 - Не найдено
      if (error.response?.status === 404) {
        toastService.error('Ресурс не найден');
      }

      // Обработка 422 - Ошибка валидации
      if (error.response?.status === 422) {
        const errors = error.response.data.errors;
        const firstError = Object.values(errors)[0]?.[0];
        if (firstError) {
          toastService.error(firstError);
        }
      }

      // Обработка 429 - Слишком много запросов
      if (error.response?.status === 429) {
        toastService.warn('Слишком много запросов. Пожалуйста, подождите');
      }

      // Обработка 500 - Внутренняя ошибка сервера
      if (error.response?.status === 500) {
        toastService.error('Внутренняя ошибка сервера');
        console.error('Server error:', error.response.data);
      }

      // Обработка сетевых ошибок
      if (!error.response) {
        toastService.error('Ошибка соединения с сервером');
      }

      // Логирование ошибок в dev режиме
      if (configService.get('api.debug', false)) {
        console.error('[API Error]', {
          status: error.response?.status,
          data: error.response?.data,
          config: error.config
        });
      }

      return Promise.reject(error);
    }
  );

  isInitialized = true;
  console.log('✅ API инициализирован с baseURL:', api.defaults.baseURL);
  
  return api;
};
export default api;
















/*
// Утилиты для работы с API
export const apiUtils = {

  // Отмена запросов
  cancelToken: axios.CancelToken,
  isCancel: axios.isCancel,

  // Формирование FormData
  toFormData(data) {
    const formData = new FormData();
    Object.keys(data).forEach(key => {
      if (data[key] !== null && data[key] !== undefined) {
        formData.append(key, data[key]);
      }
    });
    return formData;
  },

  // Загрузка файла с прогрессом
  async uploadFile(url, file, onProgress) {
    const formData = new FormData();
    formData.append('file', file);

    return api.post(url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (progressEvent) => {
        if (onProgress) {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          onProgress(percentCompleted);
        }
      }
    });
  }
};
*/